// extracted by mini-css-extract-plugin
module.exports = {"desktopOnlyOverlay":"styles_desktopOnlyOverlay__1cc5j","icon":"styles_icon__3739U","message":"styles_message__2z_Pp"};